import * as React from "react";
const SvgFiRrCircleW = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-circle-w_svg__a)">
      <path
        fill="#062147"
        d="M12.04.02c-6.618 0-12 5.382-12 12s5.382 12 12 12c6.616 0 12-5.383 12-12s-5.385-12-12-12m0 22c-5.515 0-10-4.486-10-10s4.484-10 10-10c5.514 0 10 4.486 10 10s-4.486 10-10 10m5.993-14.644-.933 8.741c-.196 1.076-.946 1.896-2.134 1.896-.916 0-1.733-.582-2.07-1.495l-.87-2.494-.887 2.482c-.364.983-1.254 1.595-2.237 1.497-.96-.081-1.729-.81-1.914-1.81l-.944-8.817a1 1 0 1 1 1.988-.213l.933 8.742s.036.1.107.106c.075.008.14-.064.186-.19l1.837-5.14a1 1 0 0 1 .941-.662h.004a1 1 0 0 1 .94.67l1.794 5.153c.043.112.114.191.204.17.03-.003.108-.01.141-.184l.922-8.666a.99.99 0 0 1 1.101-.888 1 1 0 0 1 .888 1.1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-circle-w_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCircleW;
